import React, { useState, useEffect } from "react";
import "./CaseTypeOptions.css";

const CaseType = ({ api, PartyID }) => {
    const [caseType, setCaseType] = useState("");
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState("");
    const [saving, setSaving] = useState(false);
    const [caseManagerAccess, setCaseManagerAccess] = useState(false);
    const [reportPublished, setReportPublished] = useState(false);
    const caseID = document.getElementById("CaseIDHiddenField")?.value;
    const partyID = PartyID;

    useEffect(() => {
        const loadCaseType = async () => {
            try {
                setError(null);
                const response = await api.transact('GetCaseType', { CaseID: caseID, PartyID: partyID });

                if (response?.apiResult) {
                    const apiResult = typeof response.apiResult === 'string'
                        ? JSON.parse(response.apiResult)
                        : response.apiResult;

                    const caseTypeValue = apiResult?.Result?.CaseType;
                    const caseManagerAccessValue = apiResult?.Result?.CaseManagerAccess;
                    const reportPublishedValue = apiResult?.Result?.ReportsPublished;
                    if (caseTypeValue) {
                        setCaseType(String(caseTypeValue).toLowerCase().trim());
                    }

                    if (caseManagerAccessValue !== undefined) {
                        setCaseManagerAccess(caseManagerAccessValue);
                    }
                    if (reportPublishedValue !== undefined) setReportPublished(reportPublishedValue);
                }
            } catch (err) {
                setError(err.message || "Failed to load case type");
            }
        };

        if (caseID) loadCaseType();
    }, [caseID, api]);

    const handleSave = async () => {
        if (!caseType) {
            setError('Please select a case type');
            return;
        }

        try {
            setSaving(true);
            setError(null);
            setSuccess("");

            await api.transact('CaseTypeSave', {
                CaseID: caseID,
                CaseType: caseType
            });

            setSaving(false);
            setSuccess(`Case type "${caseType.toUpperCase()}" saved successfully`);
            setTimeout(() => setSuccess(""), 3000);
        } catch (e) {
            setSaving(false);
            setError(e.message);
        }
    };

    return (
        <div id="casetype-tab">
            <h3>Case Type Selection</h3>
            <div className="current-selection-label">
                <strong>Current Selection:</strong> {caseType ? caseType.toUpperCase() : "None"}
            </div>
            <form>
                <div className="casetype-options">

                    {/* MSK */}
                    <label className="casetype-label">
                        <input
                            type="radio"
                            name="casetype"
                            value="msk"
                            checked={caseType === "msk"}
                            onChange={() => caseManagerAccess && setCaseType("msk")}
                            disabled={saving || reportPublished || !caseManagerAccess}
                        />

                        <div className="casetype-card">
                            <h4>Musculoskeletal</h4>
                            <p>Injuries, joints, muscles</p>
                            {/* ✅ CURRENT SELECTION BADGE */}
                            {caseType === "msk" && <span className="casetype-badge">Selected</span>}
                        </div>
                    </label>

                    {/* MH */}
                    <label className="casetype-label">
                        <input
                            type="radio"
                            name="casetype"
                            value="mh"
                            checked={caseType === "mh"}
                            onChange={() => caseManagerAccess && setCaseType("mh")}
                            disabled={saving || reportPublished || !caseManagerAccess}
                        />

                        <div className="casetype-card">
                            <h4>Mental Health</h4>
                            <p>Psychological wellbeing</p>
                            {/* ✅ CURRENT SELECTION BADGE */}
                            {caseType === "mh" && <span className="casetype-badge">Selected</span>}
                        </div>
                    </label>

                </div>

                <div className="casetype-actions">
                    {caseManagerAccess && (
                        <button
                            type="button"
                            className="casetype-button"
                            onClick={handleSave}
                            disabled={saving || reportPublished || !caseManagerAccess || !caseType}
                        >
                            {saving ? 'Saving...' : 'Save Selection'}
                        </button>
                    )}
                </div>

                {success && (
                    <div className="casetype-status">
                        <span className="casetype-text-success">{success}</span>
                    </div>
                )}

                {error && (
                    <div className="casetype-status">
                        <span className="casetype-text-danger">{error}</span>
                    </div>
                )}
                {reportPublished && (
                    <div className="casetype-status">
                        <span className="casetype-text-danger">
                            Reports for this case are already published, so the case type cannot be changed.
                        </span>
                    </div>
                )}
            </form>
        </div>
    );
};

export default CaseType;